import { useEffect, useRef, useState } from 'react';
import { BrowserMultiFormatReader } from '@zxing/browser';
export default function BoxScanner({ onScan, disabled }: { onScan: (value: string) => void; disabled: boolean }) {
  const video = useRef<HTMLVideoElement>(null); const controls = useRef<{ stop: () => void } | null>(null);
  const [active, setActive] = useState(false); const [error, setError] = useState('');
  useEffect(() => {
    if (!active || !video.current) return;
    let cancelled = false;
    const reader = new BrowserMultiFormatReader();
    reader.decodeFromVideoDevice(undefined, video.current, (result, _error, control) => {
      if (!result || cancelled) return;
      const text = result.getText();
      if (!/^WLB-[A-F0-9]{32}$/i.test(text)) { setError('Use a Whenly box label from this route.'); return; }
      control.stop(); onScan(text); setActive(false);
    }).then(control => { if (cancelled) control.stop(); else controls.current = control; })
      .catch(() => { if (!cancelled) { setError('Camera unavailable. Enter the box label below.'); setActive(false); } });
    return () => { cancelled = true; controls.current?.stop(); controls.current = null; };
  }, [active, onScan]);
  return <div className="driver-stack">{active ? <><video ref={video} style={{ width: '100%' }} muted playsInline /><button type="button" className="btn btn-secondary" onClick={() => setActive(false)}>Stop camera</button></>
    : <button type="button" className="btn btn-secondary" disabled={disabled} onClick={() => { setError(''); setActive(true); }}>Read box label with camera</button>}{error && <p role="alert">{error}</p>}</div>;
}
